module.exports = __webpack_public_path__ + "media/colors/JASPEM2-4-80ae3bea.png";